import { render, staticRenderFns } from "./hi-poptip.vue?vue&type=template&id=62c83bb8"
import script from "./hi-poptip.vue?vue&type=script&lang=ts"
export * from "./hi-poptip.vue?vue&type=script&lang=ts"
import style0 from "./hi-poptip.vue?vue&type=style&index=0&id=62c83bb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports